import { FC, useEffect, useState } from 'react';

import { useAuthStore } from '@modules/auth/store';
import useOrganizationName from '@modules/my-account/hooks/useOrganizationName';
import { getPermissionsByUser, isPermissionsDevToolEnabled } from '@modules/permissions/utils';
import { usePermissions } from '../../hooks';
import { PartnerOrganization } from '@/modules/core/types/partnerType.type';
import PartnerSwitcher from '../PartnerSwitcher/PartnerSwitcher';
import { PermissionsProps } from './Permissions.types';
import { Permissions as PermissionsType } from '../../types';

const Permissions: FC<PermissionsProps> = ({ children }) => {
  const organizationName = useOrganizationName();
  const { user: currentUser, partner, updatePermissions, updatePartner } = useAuthStore();
  const { setPartnerOrganization } = usePermissions();
  const [permissions, setPermissions] = useState<PermissionsType[] | undefined>();

  /** ENVIRONMENT TESTING  */
  const hasDevTools = organizationName && isPermissionsDevToolEnabled(organizationName);
  const handleChangePartner = (selectedPartner: PartnerOrganization): void => {
    updatePartner(selectedPartner);
  };
  /** ENVIRONMENT TESTING  */

  useEffect(() => {
    if (!currentUser || !organizationName) {
      return;
    }
    setPartnerOrganization();
  }, [organizationName, partner]);

  useEffect(() => {
    if (!currentUser || !partner) {
      return;
    }

    const userPermissions = getPermissionsByUser(currentUser, partner);
    updatePermissions(userPermissions);
    setPermissions(userPermissions);
  }, [currentUser, partner]);

  return (
    <>
      {hasDevTools && <PartnerSwitcher handlerOnChange={handleChangePartner} defaultValue={partner} />}
      {permissions && children}
    </>
  );
};

export default Permissions;
